import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { useScreen } from '../../../../../hooks'
import { ContractSelect } from '../../../../Contract'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import {
  REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_BUILDING,
  REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_CONTRACT,
  REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_FLAT,
  REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_USER,
} from '../../RequestWizardForm.constants'

import { getContractParam } from './ContractIDField.utils'

function ContractIDField({ controlProps, isLoading }) {
  const { t } = useTranslation()
  const { values } = useFormikContext()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  const contractParam = getContractParam({
    building: values[REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_BUILDING],
    flat: values[REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_FLAT],
    user: values[REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_USER],
  })

  return (
    <FormikField
      Component={FormFieldSelectNG}
      Select={ContractSelect}
      apiParams={contractParam}
      controlProps={{
        ...controlProps,
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Wizard.ContractIDPlaceholderKey'),
          },
        },
      }}
      disabled={isLoading}
      fieldComponentProps={{
        disabled: isLoading,
        info: t('Wizard.ContractIDInfoKey'),
        label: `${t('Wizard.ContractIDLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      name={REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_CONTRACT}
    />
  )
}

export default ContractIDField
